//$icon-sz--sm
import IMG_BLOG from 'assets/images/support/thumb-support.png';
import IMG_TRANING from 'assets/images/support/thumb-traning.png';
import IMG_PLAYLIST from 'assets/images/support/thumb-video.png';
import IMG_YOUTUBE from 'assets/images/support/youtube-logo.png';
import ExternalLink from 'components/generic/ExternalLink.component';
import { useTranslation } from 'providers/GILT.provider';
import fromAnyToTrimmed from 'utils/converters/any/fromAnyToTrimmed.util';

import CN from './Showcase.module.scss';

const determineShowcaseData = (t) => [
  {
    id: 1,
    title: t('accountManagement.showcase.box1.title'),
    subtitle: t('accountManagement.showcase.box1.subtitle'),
    image: IMG_PLAYLIST,
    link: 'https://www.youtube.com/@getslick/playlists',
    logo: IMG_YOUTUBE,
  },
  {
    id: 2,
    title: t('accountManagement.showcase.box2.title'),
    subtitle: t('accountManagement.showcase.box2.subtitle'),
    image: IMG_BLOG,
    link: 'https://www.getslick.com/blog',
    logo: '',
  },
  {
    id: 3,
    title: t('accountManagement.showcase.box3.title'),
    subtitle: t('accountManagement.showcase.box3.subtitle'),
    image: IMG_TRANING,
    link: 'https://www.getslick.com/on-demand-training',
    logo: '',
  },
];

const Showcase = ({ tag }) => {
  const { t } = useTranslation();

  const DATA = determineShowcaseData(t);

  return (
    <div className={CN.component} data-bem="Showcase" data-tag={fromAnyToTrimmed(tag)}>
      {DATA.map((item) => (
        <div className={CN.showcaseCard} key={item.id}>
          <ExternalLink link={item.link} variant="web">
            <div className={CN.imageContainer}>
              <img src={item.image} alt={item.title} className={CN.image} />
              {item.logo && <img src={item.logo} alt="logo" className={CN.logo} />}
            </div>
            <div className={CN.textContainer}>
              <div className={CN.title}>{item.title} </div>
              <div className={CN.subTitle}>{item.subtitle} </div>
            </div>
          </ExternalLink>
        </div>
      ))}
    </div>
  );
};

export default Showcase;
